import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Header = styled.div`
  background: #f4f4f4;
  display: grid;
  grid-template-columns: 1fr 5fr 1fr;
  border-bottom: 1px solid #cecece;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 50px;
  position: sticky;
  top: 0px;
  left: 0px;
  right: 0px;
`
const HeaderText = styled.h2`
  grid-column-start: 2;
  grid-column-end: 2;
  justify-self: center;
`
const CloseButton = styled.span`
  grid-column-start: 3;
  grid-column-end: 3;
  cursor: pointer;
  color: #4a4a4a;
  justify-self: end;
  align-self: center;
  padding-right: 20px;
  font-weight: bold;
  font-size: 1.2em;
  &:hover {
    color: #4a4a4a;
  }
`

const ModalHeader = props => {
  const { text, onClose, closeButtonId } = props
  return (
    <Header>
      <HeaderText>
        {text}
      </HeaderText>
      <CloseButton id={closeButtonId} onClick={onClose}>
        X
      </CloseButton>
    </Header>
  )
}

ModalHeader.propTypes = {
  closeButtonId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}

export default ModalHeader
